import Socket from '@/utils/socket'
import type {
  luckyBagInterface,
  memberListInterface
} from '@/types/apiType/roomType'
import type {
  sendInterface,
  responseInterface,
  userEnterTheRoomBannerInterface
} from '@/types/viewsType/socketType'
import { captureException } from '@sentry/browser'
import { apiRoomIn } from '~/api/room'

export const useSocketStore = defineStore({
  id: 'socket',
  state: () => ({
    inSocket: {} as Socket<sendInterface, responseInterface>, // Socket实例
    isFirstSocketLogin: false as boolean, // socket 是否首次登录成功， 用来给 arrivedLogin 使用
    isSocketLogin: false as boolean, // socket 是否登录成功
    isReconnect: false as boolean, // 是否在重连
    // 房间部分rListInterf
    memberUserInfo: {} as memberListInterface, // 加入房间后得的个人信息
    memberHostInfo: {} as memberListInterface, // 加入房间后得的房主个人信息
    isEnterRoom: false as boolean, // 是否进入房间
    socketOnlineNum: 0 // socket 在线人数,
  }),
  actions: {
    // 初始化
    init() {
      console.log('--------------socket init()', new Date().toISOString())
      console.log('socket => 开始初始化2')
      const runtimeConfig = useRuntimeConfig()
      this.destroy()
      this.isReconnect = false
      this.socketOnlineNum = 0
      this.inSocket = new Socket<sendInterface, responseInterface>({
        url: runtimeConfig.public.socketUrl,
        debug: true,
        openCb: this.onLogin,
        heartCb: this.onHeart,
        messageCb: this.onMsg,
        reconnectCb: this.onReconnect,
        closeCb: this.onClose,
        errorCb: this.onError
      })
    },
    // 销毁
    destroy() {
      // 有才销毁
      if (this.inSocket && this.inSocket.destroy) {
        this.inSocket.destroy()
        this.isSocketLogin = false
      }
    },
    // 收到消息回调
    onMsg(res) {
      if ((res.res_data && res.res_data.errno === 0) || res.req_data) {
        this.onSuccessMsg(res)
      } else {
        this.onFailMsg(res)
      }
    },
    // 成功回调
    onSuccessMsg(res) {
      const { id, route, res_data, req_data } = res
      const data = res_data ? res_data.data : req_data // 请求和返回不一样的data字段
      const roomStore = useRoomStore()
      const publicStore = usePublicStore()
      const roomPkStore = useRoomPkStore()
      switch (route) {
        case socketResponseRoute.sendMessageReport: // 房间消息，礼物动画监听，中奖，音房邀请上麦通知
          this.onSendMessageReport(data)
          break
        case socketResponseRoute.matchSuccess: // 电话匹配
          this.onMatchSuccess(data)
          break
        case socketResponseRoute.kickoff: // 踢出登录
          // 先判断一下是否在webView
          if (!publicStore.isIOSWebView) {
            publicStore.resetLogin({
              msg: 'socket-kickoff',
              type: 'socket-kickoff'
            })
          } else {
            // 退出房间
            roomStore.quit().then(() => {
              window['appFun']('closeRoom')
            })
          }
          break
        case socketResponseRoute.ChatRoomMemberKicked: // 被主播踢出
          showToast(data.reason_msg)
          roomStore.kickedOutRoom()
          break
        case socketRequestRoute.login: // 登录成功
          console.log(
            '--------------socketRequestRoute.login',
            new Date().toISOString()
          )
          this.isFirstSocketLogin = true
          this.isSocketLogin = true
          // 调进房方法，如果在房 和 重连成功 需要重新进房
          if (this.isReconnect) {
            this.inSocket.reconnectToast?.close()
            const roomStore = useRoomStore()
            roomStore.socketEnterRoom()
          }
          this.isReconnect = false
          break
        case socketResponseRoute.sendTextReport: // 房间收到文本信息
          this.onSendTextReport(id, data)
          break
        case socketResponseRoute.chatRoomMemberIn: // 房间成员进入房间
          this.onChatRoomMemberIn(id, data)
          break
        case socketResponseRoute.chatRoomMemberExit: // 房间成员退出房间
          this.onChatRoomMemberExit(data)
          break
        case socketResponseRoute.QueueMemberUpdateNotice: // 麦位或主播位成员列表发生变化
          this.onQueueMemberUpdateNotice(data)
          break
        case socketRequestRoute.enterWithOpenChatRoom: // 进入房间
          this.onEnterWithOpenChatRoom(data)
          break
        // case socketResponseRoute.roomMicCharmPush: // 麦位魅力值推送通知
        //   this.onRoomMicCharmPush(data)
        //   break
        case socketResponseRoute.QueueMicUpdateNotice: // 麦位状态更新
          this.onQueueMicUpdateNotice(data)
          break
        case socketResponseRoute.ChatRoomManagerAdd: // 房间内设置管理员通知
          this.onChatRoomManagerAdd(data)
          break
        case socketResponseRoute.ChatRoomManagerRemove: // 房间内移除管理员通知
          this.onChatRoomManagerRemove(data)
          break
        case socketResponseRoute.ChatRoomInfoUpdated: // 麦位数量更新
          useAudioStore().onMicTotalCountUpdate(data.room_info)
          roomStore.setSocketRoomInfo(data.room_info)
          break
        case socketResponseRoute.roomReceiveSum: // 视屏房收益通知
          data.custom?.data?.receiveSum &&
            roomStore.updateDayDiamond(data.custom.data.receiveSum)
          break
        case socketResponseRoute.roomMatchPkReady: // 视频房PK匹配成功
          data.custom?.data && roomPkStore.onRoomMatchPkReady(data.custom.data)
          break
        case socketResponseRoute.roomMatchPkAction: // 视频房PK开始
          data.custom?.data && roomPkStore.onRoomMatchPkAction(data.custom.data)
          break
        case socketResponseRoute.roomMatchPkScore: // 视频房PK开始
          data.custom?.data && roomPkStore.onRoomMatchPkScore(data.custom.data)
          break
        case socketResponseRoute.roomMatchPkResult: // 视频房PK结果
          data.custom?.data && roomPkStore.onRoomMatchPkResult(data.custom.data)
          break
        default:
          // 其他请求
          break
      }
    },
    // 失败回调
    onFailMsg(res) {
      const { route, res_data, req_data } = res
      const data = res_data ? res_data : req_data // 请求和返回不一样的data字段
      const publicStore = usePublicStore()
      const roomStore = useRoomStore()
      showToast(data.errmsg)
      switch (route) {
        // 进入房间
        case socketRequestRoute.enterWithOpenChatRoom:
          // 被踢出房间
          if (res_data.errno === 100202 || res_data.errno === 100212) {
            roomStore.kickedOutRoom()
          }
          // 需要输入房间密码
          if (res_data.errno === 100207 || res_data.errno === 100208) {
            roomStore.setRoomPasswordDialogConfig({ isShow: true })
          }
          break
        // im 登录验证失败
        case socketRequestRoute.login:
          // 先判断一下是否在webView
          if (res_data.errno === 100100 && !publicStore.isIOSWebView) {
            // 重置登录
            publicStore.resetLogin({
              msg: 'socket- res_data.errno === 100100',
              type: 'socket'
            })
          }
          break
        default:
          // 其他请求
          break
      }
    },
    // 房间消息，礼物动画监听，中奖，音房邀请上麦通知
    onSendMessageReport(data) {
      const giftStore = useGiftStore()
      const giftBannerStore = useGiftBannerStore()
      const audioStore = useAudioStore()
      const roomStore = useRoomStore()
      const emojiStore = useEmojiStore()
      const detonatingStore = useDetonatingStore()
      const luckyBagStore = useLuckyBagStore()
      const publicStore = usePublicStore()
      const i18n = useNuxtApp().$i18n

      if (typeof data.custom === 'string') {
        try {
          data.custom = JSON.parse(data.custom)
        } catch (error) {
          data.custom = null
          // Sentry.captureException 捕获报错
          captureException(error)
        }
      }

      /**
       * 房间侧边动画列表条件
       *
       * 公屏礼物消息
       * 3&31：单独送礼
       * 12&121: 多人或全麦
       */
      if (
        (data.custom && data.custom.first === 3 && data.custom.second === 31) ||
        (data.custom && data.custom.first === 12 && data.custom.second === 121)
      ) {
        // 房间侧边动画列表
        giftStore.onGiftSend(data.custom.data)

        // 房间公屏信息
        // 用此字段说明是连击礼物，连击礼物等礼物动画结束才显示，在 GiftListAnimationItem.vue onBeforeUnmount 判断
        if (!data.custom.data.comboRangEnd) {
          // 非连击礼物直接显示房间公屏
          roomStore.updateChatList('put', {
            id: data.timestamp,
            type: constant.ROOM_CHAT_TYPE.CHAT_GIFT,
            content: '',
            nick: data.custom.data.nick, // 送礼人
            targetNick: data.custom.data.targetNick, // 收礼人
            targetUid: data.custom.data.targetUid || '', // 收礼人id
            targetAvatar: data.custom.data.targetAvatar, // 收礼人头像
            targetUids: data.custom.data.targetUids, // 多人收礼人

            giftId: data.custom.data.giftId, // 礼物id
            giftName: data.custom.data.giftName, // 礼物每次
            giftUrl: data.custom.data.giftUrl, // 礼物图片
            giftNum: data.custom.data.giftNum
          })
        }
      }

      // 是否符合房间设置条件（是自己房间的横幅或者没有设置隐藏其他房间礼物横幅）
      const isInTriggerRoom = data.custom?.data?.roomId === roomStore.roomId
      const isHideOtherRoomGiftBanner =
        roomStore.socketRoomInfo.hideGiftBannerOpen
      if (isInTriggerRoom || !isHideOtherRoomGiftBanner) {
        /**
         * 全服横幅 - 幸运礼物
         *
         * 100041&1&是自己: 中部返币倍数（自己才显示）
         * 100041&2: 全服横幅（目前是自己送socket才会返）
         */
        const isLuckyGift = data.custom && data.custom.first === 100041
        if ((isInTriggerRoom || !isHideOtherRoomGiftBanner) && isLuckyGift) {
          // 幸运礼物
          if (data.custom.second === 1) {
            const userStore = useUserStore()
            const { userInfo } = storeToRefs(userStore)
            // 中部返币勋章，自己才展示
            if (data.member.uid === userInfo.value.uid) {
              // 添加中部返币勋章
              giftBannerStore.setLuckyBackCoins(data.custom.data)
            }
          } else if (data.custom.second === 2) {
            // 横幅展示
            if (
              publicStore.isIOSWebView &&
              publicStore.checkIOSVersion({ version: '1.2.0' })
            ) {
              // 通知客户端播放横幅
              window['appFun']('sendMessageReport', data.custom)
            } else {
              giftBannerStore.addLuckyGiftBanner(data.custom.data)
            }
          }
        }
        /**
         * 全服横幅 - 大额礼物
         *
         * first=3|12|14 礼物总价值(goldPrice*giftNum)>=520 且 有礼物特效: 大额礼物全服横幅
         */
        const isLargeGift =
          data.custom && [3, 12, 14].includes(data.custom.first)
        if ((isInTriggerRoom || !isHideOtherRoomGiftBanner) && isLargeGift) {
          // 大额礼物
          const giftInfo = data.custom.data
          if (
            giftInfo.goldPrice * giftInfo.giftNum >= 520 &&
            (giftInfo.vggUrl || giftInfo.mp4Url)
          ) {
            if (
              publicStore.isIOSWebView &&
              publicStore.checkIOSVersion({ version: '1.2.0' })
            ) {
              // 通知客户端播放横幅
              window['appFun']('sendMessageReport', data.custom)
            } else {
              giftBannerStore.addLargeGiftBanner(giftInfo)
            }
          }
        }
      }

      // 游戏中奖者
      if (
        data.custom &&
        data.custom.first === 36 &&
        data.custom.second === 36
      ) {
        roomStore.updateChatList('put', {
          id: data.timestamp,
          content: '',
          gameWinningInfoArr: data.custom.data.content,
          type: constant.ROOM_CHAT_TYPE.GAME
        })
      }
      //语音房邀请上麦通知
      if (
        data.custom &&
        data.custom.first === 8 &&
        data.custom.second === 81 &&
        data.custom.data
      ) {
        audioStore.onInviteMessage(data.custom.data)
      }

      // 设置魅力值
      if (data.custom && data.custom.first === 21 && data.custom.second === 1) {
        if (data.custom.data?.roomId === roomStore.roomId) {
          audioStore.onRoomMicCharmPush(data.custom.data.latestCharm)
        }
      }

      //房间内送礼金额通知
      if (
        data.custom &&
        data.custom.first === 100029 &&
        data.custom.second === 1
      ) {
        roomStore.updateDayGold(data.custom.data.dayGold)
      }

      // 发送表情通知
      if (data.custom && data.custom.first === 9 && data.custom.second === 91) {
        emojiStore.onUserSendEmoji(data.custom.data)
      }

      /**
       * 禁/解麦、麦位通知 68
       * 禁/解麦、麦位通知(批量) 68&1
       *
       * 自定义发送的公屏消息 29&29
       */
      if (
        data.custom &&
        (data.custom.first === 68 ||
          (data.custom.first === 29 && data.custom.second === 29))
      ) {
        const languageStore = useLanguageStore()
        try {
          const content = JSON.parse(data.custom.data.content)
          let contentString = ''
          content.forEach((item) => {
            contentString += `<i style="color: ${item.color};">${item[languageStore.languageInfo.value] || item.string}</i>`
          })
          const params = {
            id: data.timestamp,
            type: constant.ROOM_CHAT_TYPE.ROOM_UPDATE,
            content: contentString,
            nick: data.member?.nick || '',
            uid: data.member?.uid || 0
          }
          if (data.custom.first === 29 && data.custom.second === 29) {
            delete params.nick
            delete params.uid
          }
          // 禁/解麦、麦位消息
          roomStore.updateChatList('put', params)
        } catch (error) {
          console.error(error)
        }
      }

      /**
       * 设置房间信息(开关公屏聊天、座驾特效)
       */
      if (data.custom && data.custom.first === 8) {
        const { second } = data.custom
        const member =
          typeof data.member === 'string'
            ? JSON.parse(data.member)
            : data.member
        const i18n = useNuxtApp().$i18n
        if (second === 153 || second === 154) {
          if (second === 154) {
            // 关闭公屏、先清空公屏
            roomStore.updateChatList('init')
          }
          roomStore.updateChatList('put', {
            id: Date.now(),
            type: constant.ROOM_CHAT_TYPE.ROOM_UPDATE,
            content: `${member.nick} ${second === 153 ? i18n.t('room.OpenChatZone') : i18n.t('room.CloseChatZone')}`,
            nick: member.nick
          })
        }
        if (second === 155 || second === 156) {
          roomStore.updateChatList('put', {
            id: Date.now(),
            type: constant.ROOM_CHAT_TYPE.ROOM_UPDATE,
            content: `${member.nick} ${second === 155 ? i18n.t('room.LowValueStarted') : i18n.t('room.LowValueStop')}`,
            nick: member.nick
          })
        }
        if (second === 157 || second === 158) {
          roomStore.updateChatList('put', {
            id: Date.now(),
            type: constant.ROOM_CHAT_TYPE.ROOM_UPDATE,
            content:
              second === 157
                ? i18n.t('room.OpenRideEffect')
                : i18n.t('room.CloseRideEffect'),
            nick: member.nick
          })
        }
      }

      /**
       * 清空魅力值
       */
      if (
        data.custom &&
        data.custom.first === 21 &&
        data.custom.second === 211
      ) {
        audioStore.onRoomMicCharmPush({})
      }

      /**
       * 更新爆蛋进度
       * 33& (1|2) 更新进度
       * 33&3 爆弹抢礼结束
       */
      if (data.custom && data.custom.first === 33 && publicStore.isIOSWebView) {
        try {
          const json = JSON.parse(data.custom.data.params)
          detonatingStore.onDetonatingUpdate(json)
          // 爆弹抢礼结束，清空升级的倒计时
          if (data.custom.second === 3) {
            detonatingStore.stopLocalUpgradeCountDown()
          }
        } catch (error) {
          console.error('解析错误', error)
        }
      }

      /**
       * 幸运红包通知
       * 100038 显示红包
       * 100039 红包已领完，隐藏红包
       */
      if (
        data.custom &&
        publicStore.isIOSWebView &&
        publicStore.checkIOSVersion({ version: '1.5.0' })
      ) {
        const member =
          typeof data.member === 'string'
            ? JSON.parse(data.member)
            : data.member || {}
        if (data.custom.first === 100038) {
          luckyBagStore.setLuckyBagInfo(data.custom.data)
          // 公屏消息
          roomStore.updateChatList('put', {
            uid: member.uid,
            content: i18n.t('room.StartLuckyBag'),
            type: constant.ROOM_CHAT_TYPE.PROMPT_TEXT
          })
        } else if (data.custom.first === 100039) {
          // 已抢完
          luckyBagStore.setLuckyBagInfo(null)
        } else if (data.custom.first === 100040) {
          // 播放幸运红包全服横幅
          if (data.custom.data?.bagType === constant.ROOM_LUCKY_BAG_TYPE.ALL) {
            luckyBagStore.addLuckyBagBanner(data.custom.data)
          }
        }
      }
    },
    /**
     * on 通话接听接受
     * 通话场景
     * type: 1:收到视频呼叫;2:关闭通话;3:钻石不足以维持一分钟;4:匹配成功,或者说女生被强制拉入1v1（就是女生没有在匹配也会收到这条im）;5:接受呼叫;6:体验券将要结束，7：对方拒绝接听，8：挂断;
     *       9: 视频通话（人脸检测通知）;10:视频通话，正式开始计费;11: 新版本余额不足，兼容处理（v1.0.1.2）;
     *       12:男生匹配成功im;13:收到匹配弹窗im,弹窗让女生选择是否接受;14:对方已在通话中;15:兜底策略，怕呼叫收不到弹窗，这个是确认弹窗，16：女生匹配取消
     * 目前H5暂时不做接听功能
     * */
    onMatchSuccess(data) {
      const callStore = useCallStore()
      const custom = JSON.parse(data.custom.data)
      switch (custom.type) {
        case 2: // 通话关闭
          if (!custom.time || custom.time <= 0) {
            callStore.onCallClose(custom.msg)
          }
          break
        case 3: // 拨打方钻石不足做提示
          this.onCallRoomNotEnoughDiamondTips(custom.msg)
          break
        case 4: // 男生匹配成功
          callStore.onCallSuccess(custom.matchUid, 2)
          break
        case 5: // 对方接听
          callStore.onCallSuccess(custom.acceptUid, 1)
          break
        case 7: // 对方拒绝接听
          callStore.onCallRejected(custom.refuseUid)
          break
        case 8: // 通话挂断
          if (!custom.time || custom.time <= 0) {
            callStore.onCallClose(custom.msg)
          }
          break
        case 10: // 视频通话，正式开始计费
          callStore.onStartBilling()
          break
        case 12: // 男生匹配成功
          callStore.onCallSuccess(custom.acceptUid, 2)
          break
        default:
          break
      }
    },

    /**
     * send 发送消息
     * @param {string} content 文本
     */
    sendText(content: string, atUser?: { atUid: number; atNick: string }) {
      if (!content.trim()) return Promise.reject(false)
      const roomStore = useRoomStore()
      return this.privateSend({
        route: socketRequestRoute.sendText,
        req_data: {
          ...atUser,
          room_id: roomStore.roomInfo.roomId,
          member: JSON.stringify(this.memberUserInfo),
          content
        }
      })
    },
    /**
     * send 发送sendMessage，给客户端移除遮罩层, 上麦邀请
     */
    sendMessage(req_data) {
      if (!this.isEnterRoom) return // 进房后才正常执行
      return this.privateSend(
        {
          route: socketRequestRoute.sendMessage,
          req_data
        },
        true
      )
    },
    // send 进入房间
    /**
     *  room_type -1:'',5:语音房,9:视频房,,10:1v1视频聊天
     * **/
    snedEnterWithOpenChatRoom(info: {
      uid: number | string
      type: 5 | 9 | 10
      pwd?: string | null
      avatar?: string
      title?: string
    }) {
      this.isEnterRoom = false
      return this.privateSend({
        route: socketRequestRoute.enterWithOpenChatRoom,
        req_data: {
          room_uid: info.uid, // 房主uid
          room_type: info.type, // 房间类型
          room_pwd: info.pwd || null, //房间密码
          avatar: info.avatar || '',
          title: info.title || '',
          is_can_connect_mic: 1, // 是否开启连麦
          ticket: localStorage.getItem('ticket') as string,
          micTotalCount: 4,
          reconnect: this.isReconnect ? 1 : 0 //是否重连 1 0
        }
      })
    },
    // send 退出房间
    // 退出房间初始化
    sendExitChatRoom() {
      const roomStore = useRoomStore()
      this.isEnterRoom = false
      this.memberUserInfo = { uid: 0, avatar: '', nick: '' }
      this.socketOnlineNum = 0
      roomStore.setIsHostLive(false)
      this.privateSend({
        route: socketRequestRoute.exitChatRoom,
        req_data: {
          room_id: roomStore.roomId
        }
      })
    },
    /**
     * 统一使用发送
     * @param obj : 发送信息，
     * @param isNeedRoom  是否判断进房
     * */
    privateSend(obj: sendInterface, isNeedRoom?: boolean) {
      const isApp = common.checkVersion().app

      if (isApp) {
        console.log('socket => privateSend', obj)
        // App代发送消息

        window['appFun']('socketSend', obj)
        return Promise.resolve(true)
      }

      return this.arrivedLogin().then(() => {
        // 判断当前网络
        if (!navigator.onLine) {
          showToast('The network is currently unavailable.')
          return Promise.reject('The network is currently unavailable.')
        }

        // 判断是否登录成功，登录成功才发送消息
        if (!this.isSocketLogin) {
          showToast('Reconnecting or logging in, please wait.')
          return Promise.reject('Reconnecting or logging in, please wait.')
        }

        // isNeedRoom 为 true 就需要判断是否进房成功
        if (isNeedRoom && !this.isEnterRoom) {
          showToast("Didn't enter the room.")
          return Promise.reject("Didn't enter the room.")
        }

        if (
          this.inSocket.options.debug &&
          obj.route !== socketRequestRoute.heartbeat
        ) {
          console.log('socket => send:', obj)
        }

        const uid = localStorage.getItem('loginInfo')
          ? JSON.parse(localStorage.getItem('loginInfo') as string).uid
          : 0
        // 统一加上uid，方便定位问题
        obj.uid = uid
        console.log('--------------send ', obj.route, new Date().toISOString())
        return this.inSocket.send(obj)
      })
    },
    /**
     * 同步等待是否登录
     * */
    arrivedLogin() {
      return new Promise((resolve, reject) => {
        if (this.isFirstSocketLogin) {
          resolve(true)
        }
        const interval = 20
        let timeOut = 4000
        const timer = setInterval(() => {
          timeOut -= interval
          if (timeOut < 1) {
            clearInterval(timer)
            reject('catching timed out')
          }
          if (this.isFirstSocketLogin) {
            clearInterval(timer)
            resolve(true)
          }
        }, interval)
      })
    },
    // on 部分
    // on 进入房间
    onEnterWithOpenChatRoom(data) {
      const audioStore = useAudioStore()
      const roomStore = useRoomStore()
      // FIXME: 视频房同步客户端的，视频房只用声网SDK
      if (roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE) {
        data.room_info.audioChannel = 1
      }

      // 记录进入房间
      apiRoomIn({
        roomUid: data.room_info.roomId,
        roomType: roomStore.roomType
      })

      // const trtcStore = useTrtcStore()
      // const agoraStore = useAgoraStore()
      // 设置进房成功
      this.isEnterRoom = true

      this.socketOnlineNum = 0

      this.memberUserInfo = data.member
      this.memberHostInfo = data.room_user

      // 初始化语音房麦位等信息 视频房PK时也需要麦位信息，这里注释判断
      // if (roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE) {
      audioStore.initData(data)
      // }

      // 如果房间设置了进房播报
      if (data.room_info.playInfo?.trim()) {
        roomStore.updateChatList('put', {
          uid: data.member.uid,
          content: data.room_info.playInfo,
          type: constant.ROOM_CHAT_TYPE.PROMPT_TEXT
        })
      }

      // 设置声网key,目前SDK参数用接口接受
      // agoraStore.setChannelToken(data.agora.key)
      // 设置腾讯相关key和id,目前SDK参数用接口接受
      // trtcStore.setTrtcAppId(Number(data.room_info.trtcAppid))
      // trtcStore.setUserSig(data.room_info.userSig)
      // trtcStore.setPrivateMapKey(data.room_info.privateMapKey)

      // onEnterRoom
      roomStore.onEnterRoomSuccess(data)
    },
    // on 登录回调
    onLogin() {
      console.log(
        '--------------onLogin this.inSocket.send',
        new Date().toISOString()
      )
      this.inSocket.send({
        route: socketRequestRoute.login,
        req_data: {
          page_name: 5,
          uid: localStorage.getItem('loginInfo')
            ? JSON.parse(localStorage.getItem('loginInfo') as string).uid
            : 0,
          ticket: localStorage.getItem('ticket') as string
        }
      })
    },
    // on 心跳回调
    onHeart() {
      const roomStore = useRoomStore()
      this.privateSend({
        route: socketRequestRoute.heartbeat,
        req_data: {
          uid: localStorage.getItem('loginInfo')
            ? JSON.parse(localStorage.getItem('loginInfo') as string).uid
            : 0,
          room_id: roomStore.roomId,
          roomUid: roomStore.roomUid
        }
      })
    },
    // on 重连监听
    onReconnect() {
      this.isReconnect = true
      this.isSocketLogin = false
    },
    /**
     * on 关闭
     */
    onClose(e) {
      console.log('socket => onClose', e, JSON.stringify(e))
      console.log('socket => onClose isTrusted:', e.isTrusted)
      console.log('socket => onClose Code:', e.code) // 查看 code 是否为空
      console.log('socket => onClose Reason:', e.reason) // 查看 reason 是否为空
      console.log('socket => onClose Was clean:', e.wasClean) // 查看 wasClean 是否为空
      this.isSocketLogin = false
    },
    /**
     * on 关闭
     */
    onError(e) {
      console.log('socket => onError', e)
      this.isSocketLogin = false
    },
    // on 房间收到文本信息
    onSendTextReport(id, data) {
      const roomStore = useRoomStore()
      const member = JSON.parse(data.member)
      roomStore.updateChatList('put', {
        id: id,
        nick: member.nick,
        uid: member.uid || member.account,
        content: data.content,
        type: constant.ROOM_CHAT_TYPE.CHAT_TEXT,
        translateLoading: false,
        translateContent: '',
        atUid: data.atUid,
        atNick: data.atNick
      })
    },
    // 麦位或主播位成员列表发生变化
    onQueueMemberUpdateNotice(data) {
      /*
        key 麦位排序
        min_info 麦位信息
        value 麦位用户信息
        type 1上麦 2下麦
        connect_mic_type 0语音 1视频 2invalid 3PK
        */
      const roomStore = useRoomStore()
      const audioStore = useAudioStore()

      // 上麦
      if (data.type === 1) {
        // 更新在线成员
        roomStore.getMemberList(true)

        if (data.key === -1) {
          roomStore.setIsHostLive(true) // 主播开播或复播
        }
      } else if (data.type === 2) {
        // 下麦
        if (
          data.key === -1 ||
          data.value?.uid === roomStore.anchorInfoStorage.uid
        ) {
          roomStore.setIsHostLive(false) // 主播下播
        }
      }

      // 语音房
      if (
        roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE ||
        roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE
      ) {
        audioStore.onQueueMemberUpdateNotice(data)
      }
    },
    // on 房间成员退出房间
    onChatRoomMemberExit(data) {
      const roomStore = useRoomStore()
      this.socketOnlineNum = data.online_num
      roomStore.getMemberList()
      roomStore.updateMemberList(2, data.uid)
    },
    // on 房间成员进入房间
    onChatRoomMemberIn(id, data) {
      const roomStore = useRoomStore()
      const giftBannerStore = useGiftBannerStore()
      const giftStore = useGiftStore()
      const userStore = useUserStore()
      this.socketOnlineNum = data.online_num
      roomStore.getMemberList()
      roomStore.updateMemberList(1, data.member.uid, data.member)
      // 成员进房消息
      roomStore.updateChatList('put', {
        id: id,
        nick: data.member.nick,
        uid: data.member.uid,
        content: '',
        type: constant.ROOM_CHAT_TYPE.ENTER_ROOM
      })

      /**
       * 添加进房动画到横幅
       * vip 或 财富等级>=10 才有进房横幅
       */
      if (
        (data.member.vipId && data.member.vipId > 0) ||
        data.member.exper_level >= 10
      ) {
        giftBannerStore.addUserEnterTheRoomBanner(data.member)
      }

      /**
       * 添加进房座驾特效
       * 房间开启座驾特效设置才添加
       */
      if (
        roomStore.roomId &&
        ((!roomStore.socketRoomInfo.showOtherEnterAnimSwitch &&
          !userStore.userInfo.banGiftCarAnimation) ||
          data.member.uid === userStore.userInfo.uid)
      ) {
        if (data.member.isMp4) {
          // mp4
          giftBannerStore.addEnterRideEffects({
            mp4Url: data.member.mp4Url
          } as userEnterTheRoomBannerInterface)
        } else if (data.member.car_url) {
          // svga
          giftBannerStore.addEnterRideEffects({
            car_url: data.member.car_url
          } as userEnterTheRoomBannerInterface)
        }
      }
    },
    // 视频通话钻石不足提示
    onCallRoomNotEnoughDiamondTips(msg: string) {
      const roomStore = useRoomStore()
      const publicStore = usePublicStore()
      roomStore.updateChatList('put', {
        content: msg,
        type: constant.ROOM_CHAT_TYPE.PROMPT_TEXT
      })
      publicStore.setShowRechargePopup(true)
    },
    // // 语音房 麦位魅力值推送通知
    // onRoomMicCharmPush(data) {
    //   const audioStore = useAudioStore()
    //   audioStore.onRoomMicCharmPush(data)
    // },
    // 语音房 麦位状态更新
    onQueueMicUpdateNotice(data) {
      const audioStore = useAudioStore()
      audioStore.onQueueMicUpdateNotice(data)
    },
    //语音房 设置管理员通知
    onChatRoomManagerAdd(data) {
      const audioStore = useAudioStore()
      audioStore.onChatRoomManagerAdd(data)
    },
    //语音房 移除管理员通知
    onChatRoomManagerRemove(data) {
      const audioStore = useAudioStore()
      audioStore.onChatRoomManagerRemove(data)
    }
  },
  persist: {
    key: 'socketStore',
    paths: ['inSocket']
  }
})
